module.exports = __webpack_public_path__ + "img/importBaremo.d3990157.png";